import { createColumnHelper } from "@tanstack/react-table";
import { useTranslation } from "react-i18next";
import { RolesEnum } from "@/constants/enums/roles.enum";
import { useRoleLabels } from "@/hooks/useEnumLabels";
import { GetAllCompanyDto } from "@/types/api/api-types";
import StyledTable from "@/components/styled/StyledTable";

type GeneralInfoUsersProps = {
  company?: GetAllCompanyDto;
};

const columnHelper = createColumnHelper<GetAllCompanyDto["user"][number]>();

export const GeneralInfoUsers = ({ company }: GeneralInfoUsersProps) => {
  const { t } = useTranslation("boClients");
  const roleLabels = useRoleLabels();
  const columns = [
    columnHelper.display({
      id: "user",
      header: t("clientUsers.columns.user"),
      meta: "text-left",
      enableSorting: false,
      cell: (info) => info.row.original.firstName + " " + info.row.original.lastName,
    }),
    columnHelper.display({
      id: "phone",
      header: t("clientUsers.columns.phone"),
      meta: "text-left",
      cell: (info) => info.row.original.mobilePhoneNumber,
    }),
    columnHelper.display({
      id: "email",
      header: t("clientUsers.columns.email"),
      meta: "text-left",
      cell: (info) => info.row.original.email,
    }),
    columnHelper.display({
      id: "role",
      header: t("clientUsers.columns.role"),
      meta: "text-left",
      cell: (info) => (
        <div className="w-fit rounded-2xl border border-gray-200 bg-gray-50 px-3 py-1">
          <p className="text-sm font-medium text-gray-700">
            {roleLabels[info.row.original.role as RolesEnum] ?? info.row.original.role}
          </p>
        </div>
      ),
    }),
  ];

  return (
    <div className="flex w-full flex-1 flex-col gap-6 lg:px-8">
      <div className="flex flex-row justify-between gap-2 border-0 border-b border-gray-200 pb-5">
        <div className="items-left flex flex-col gap-2">
          <h2 className="text-lg font-semibold">{t("clientUsers.title")}</h2>
          <p className="text-sm text-gray-600">{t("clientUsers.subtitle")}</p>
        </div>
      </div>
      <div className="flex flex-col gap-10">
        <StyledTable data={company?.user || []} columns={columns} />
      </div>
    </div>
  );
};
